import React from "react";
import { AlertTriangle, X } from "lucide-react";
import Button from "./Button";

const ConfirmationModal = ({
  isLoading = false,
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger", // 'danger', 'warning', 'info'
  icon = AlertTriangle,
}) => {
  if (!isOpen) return null;

  const Icon = icon;

  const getVariantStyles = () => {
    switch (variant) {
      case "danger":
        return {
          iconColor: "text-red-500",
          iconBg: "bg-red-50",
          buttonVariant: "danger",
        };
      case "warning":
        return {
          iconColor: "text-yellow-500",
          iconBg: "bg-yellow-50",
          buttonVariant: "warning",
        };
      case "info":
        return {
          iconColor: "text-blue-500",
          iconBg: "bg-blue-50",
          buttonVariant: "primary",
        };
      default:
        return {
          iconColor: "text-gray-500",
          iconBg: "bg-gray-50",
          buttonVariant: "primary",
        };
    }
  };

  const styles = getVariantStyles();

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
        aria-hidden
      />

      {/* Modal — centered on all viewports */}
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white text-left shadow-xl overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div
              className={`w-10 h-10 rounded-full ${styles.iconBg} flex items-center justify-center`}
            >
              <Icon size={20} className={styles.iconColor} />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          <p className="text-gray-600">{message}</p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-end space-x-3">
          <Button variant="secondary" onClick={onClose} size="md">
            {cancelText}
          </Button>
          <Button
            loading={isLoading}
            variant={styles.buttonVariant}
            onClick={handleConfirm}
            size="md"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
